import {
  SET_ACTIVE_VEHICLE
} from '../actions';

export default function (state = {}, action) {

  switch(action.type) {
    case SET_ACTIVE_VEHICLE:
      return action.payload;

    default:
      return state;
  }
}